import React, { Component } from 'react';
import { connect } from 'react-redux'

import logo from '../../../../images/LOGO_PATHE.png';
import Config from "../../../../config/config";
// import { bindActionCreators } from 'redux'
// import { connect } from 'react-redux'
// import { startLogin, startQuiz } from "../../../store/actions/appstate";
// import { BrowserRouter as Router } from 'react-router-dom';

class NameInput extends Component {

	constructor(props) {
        super(props);
        // this.state = {userCode: this.props.match.params.id};
        console.log('code not found page!!')
        // this.buttonClicked = this.buttonClicked.bind(this);
        this.state = {name: "", code: this.props.roomCode.isHardcoded ? this.props.roomCode.code : "", step: 1, hasError: this.props.roomCode.hasError};

        this.nameChange = this.nameChange.bind(this);
        this.codeChange = this.codeChange.bind(this);
        this.startGame = this.startGame.bind(this);        
    }

	componentDidMount() {
		window.gtag('config', Config.googleAnalyticsCode, {
			'page_title' : 'Login-Name',
			'page_path': '/login/name'
		});
	}

    componentWillReceiveProps(nextProps) {
        // You don't have to do this check first, but it can help prevent an unneeded render
        if (nextProps.roomCode.hasError !== this.state.hasError) {
            if (nextProps.roomCode.hasError) { 
                this.setState({code: ""});                
                const codeInput = document.getElementById("codeInput");
                codeInput.focus();
            }
            this.setState({ hasError: nextProps.roomCode.hasError });                
        }
    }

    nameChange(e) {
        const name = e.target.value;
        console.log('name=', name)
        this.setState({name: name});
    }

    codeChange(e) {
        const code = e.target.value;
        console.log('code=', code)
        if (code.length > 0) this.setState({hasError: false});
        this.setState({code: code});        
    }

    keyPressHandler(event) {
        if (event.charCode === 13 && document && document.activeElement) {
            document.activeElement.blur();
            window.scrollTo(0, 0);
        }
    }

    startGame() {
        console.log('start game')
        this.props.enterName(this.state.name, this.state.code);
    }

    goToStep2 = () => {
        this.setState({step: 2});
    }

	render() {
        const step1Style = {display: this.state.step === 1 ? "block" : "none"};
        const step2Style = {display: this.state.step === 2 ? "block" : "none"};
        const errorDiv = this.state.hasError ? <div className="code-error-message">Weet je zeker dat je de goede code hebt ingevoerd?</div> : null;
        return(
            <div className="enterbioscode">
                <div className="container">
                    <div className="logo" ><img src={logo} width="100%" alt="logo" /></div>
                    <div className="step-1" style={step1Style}>
                        <p className="nameLabel">Voornaam</p>
                        <input className="roominput nameInput" maxLength="21" value={this.state.name} onChange={this.nameChange} onKeyPress={this.keyPressHandler} autoFocus />
                        <div className="step-1-button">
                            <button type="button" className="saveNameButton btn btn-block btn-warning btn-lg" onClick={this.goToStep2}>VERDER</button>
                        </div>
                    </div>
                    <div className="step-2" style={step2Style}>
                        { !this.props.roomCode.isHardcoded ?
                            <div className="roomCodeBlock">
                                <p className="nameLabel">Code</p>
                                <input id="codeInput" className="roominput codeInput" type="number" maxLength="4" max="9999" value={this.state.code} onChange={this.codeChange} onKeyPress={this.keyPressHandler} />
                                <br/>
                            </div> : null
                        }
                        {errorDiv}
                        <div className="ikdoemee">
                            <button type="button" className="saveNameButton btn btn-block btn-warning btn-lg" onClick={this.startGame}>DEELNEMEN!</button>
                        </div>
                    </div>
                    <div className="curtains"></div>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        appstate: state.appstate,
        user: state.user,
        roomCode: state.login.roomCode
    }
}

function mapDispatchToProps(dispatch) {
    return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(NameInput)


// WEBPACK FOOTER //
// ./src/components/pages/Login/NameInput/NameInput.js